
// // import styles from "./Inventory.module.css";

// // export default function Inventory({ inventory }) {

// //   if (!inventory) return null;

// //   const roomCategories = [
// //     { label: "Deluxe Rooms", value: inventory.deluxe_rooms },
// //     { label: "Executive Rooms", value: inventory.executive_rooms },
// //     { label: "Premium Rooms", value: inventory.premium_rooms },
// //     { label: "Club Rooms", value: inventory.club_rooms },
// //     { label: "Luxury Rooms", value: inventory.luxury_rooms },
// //     { label: "Studio Rooms", value: inventory.studio_rooms },
// //     { label: "Junior Suites", value: inventory.junior_suites },
// //     { label: "Executive Suites", value: inventory.executive_suites },
// //     { label: "Presidential Suites", value: inventory.presidential_suites },
// //     { label: "Villas", value: inventory.villas },
// //     { label: "Cottages", value: inventory.cottages },
// //     { label: "Bungalows", value: inventory.bungalows },
// //   ].filter(room => room.value);

// //   return (
// //     <section className={styles.section}>

// //       <h2 className={styles.heading}>
// //         Hotel Inventory
// //       </h2>

// //       <div className={styles.summary}>

// //         <div className={styles.card}>
// //           <span>Total Rooms</span>
// //           <strong>{inventory.total_rooms || "-"}</strong>
// //         </div>

// //         <div className={styles.card}>
// //           <span>Total Suites</span>
// //           <strong>{inventory.total_suites || "-"}</strong>
// //         </div>

// //       </div>

// //       {roomCategories.length > 0 && (

// //         <>
// //           <h3 className={styles.subHeading}>
// //             Room Categories
// //           </h3>

// //           <div className={styles.categories}>

// //             {roomCategories.map(room => (

// //               <div
// //                 key={room.label}
// //                 className={styles.category}
// //               >
// //                 <span>{room.label}</span>

// //                 <strong>{room.value}</strong>

// //               </div>

// //             ))}

// //           </div>

// //         </>

// //       )}

// //     </section>
// //   );
// // }




// import styles from "./Inventory.module.css";

// export default function Inventory({ inventory }) {

//   if (!inventory) return null;

//   const roomCategories = [
//     { label: "Deluxe Rooms", value: inventory.deluxe_rooms },
//     { label: "Executive Rooms", value: inventory.executive_rooms },
//     { label: "Premium Rooms", value: inventory.premium_rooms },
//     { label: "Club Rooms", value: inventory.club_rooms },
//     { label: "Luxury Rooms", value: inventory.luxury_rooms },
//     { label: "Studio Rooms", value: inventory.studio_rooms },
//     { label: "Junior Suites", value: inventory.junior_suites },
//     { label: "Executive Suites", value: inventory.executive_suites },
//     { label: "Presidential Suites", value: inventory.presidential_suites },
//     { label: "Villas", value: inventory.villas },
//     { label: "Cottages", value: inventory.cottages },
//     { label: "Bungalows", value: inventory.bungalows },
//   ].filter(room => room.value);


//   const hasRemarks = !!inventory.remarks;

//   return (
//     <section className={styles.section}>

//       <h2 className={styles.heading}>
//         Hotel Inventory
//       </h2>

//       <div className={styles.summary}>

//         <div className={styles.card}>
//           <span>Total Rooms</span>
//           <strong>{inventory.total_rooms || "-"}</strong>
//         </div>

//         <div className={styles.card}>
//           <span>Total Suites</span>
//           <strong>{inventory.total_suites || "-"}</strong>
//         </div>

//       </div>

//       {roomCategories.length > 0 && (

//         <>
//           <h3 className={styles.subHeading}>
//             Room Categories
//           </h3>

//           <div className={styles.categories}>

//             {roomCategories.map(room => (

//               <div
//                 key={room.label}
//                 className={styles.category}
//               >
//                 <span>{room.label}</span>

//                 <strong>{room.value}</strong>

//               </div>

//             ))}

//           </div>

//         </>

//       )}

//       {hasRemarks && (
//   <div className={styles.remarks}>
//     <h3 className={styles.subHeading}>
//       Additional Information
//     </h3>

//     <p className={styles.remarksText}>
//       {inventory.remarks}
//     </p>
//   </div>
// )}

//     </section>
//   );
// }


import styles from "./Inventory.module.css";

export default function Inventory({ inventory }) {

  if (!inventory) return null;

  const roomCategories = [
    { label: "Deluxe Rooms", value: inventory.deluxe_rooms },
    { label: "Executive Rooms", value: inventory.executive_rooms },
    { label: "Premium Rooms", value: inventory.premium_rooms },
    { label: "Club Rooms", value: inventory.club_rooms },
    { label: "Luxury Rooms", value: inventory.luxury_rooms },
    { label: "Studio Rooms", value: inventory.studio_rooms },
    { label: "Junior Suites", value: inventory.junior_suites },
    { label: "Executive Suites", value: inventory.executive_suites },
    { label: "Presidential Suites", value: inventory.presidential_suites },
    { label: "Villas", value: inventory.villas },
    { label: "Cottages", value: inventory.cottages },
    { label: "Bungalows", value: inventory.bungalows },
    { label: "Apartments", value: inventory.apartments },
    { label: "Tent Rooms", value: inventory.tent_rooms },
  ].filter(room => room.value);

  const hasRemarks = !!inventory.remarks;

  return (
    <section className={styles.section}>

      <h2 className={styles.heading}>
        Hotel Inventory
      </h2>

      <div className={styles.summary}>

        <div className={styles.card}>
          <span>Total Rooms</span>
          <strong>{inventory.total_rooms || "-"}</strong>
        </div>

        <div className={styles.card}>
          <span>Total Suites</span>
          <strong>{inventory.total_suites || "-"}</strong>
        </div>

      </div>

      {roomCategories.length > 0 && (
        <>
          <h3 className={styles.subHeading}>
            Room Categories
          </h3>

          <div className={styles.categories}>
            {roomCategories.map(room => (
              <div
                key={room.label}
                className={styles.category}
              >
                <span>{room.label}</span>
                <strong>{room.value}</strong>
              </div>
            ))}
          </div>
        </>
      )}

      {hasRemarks && (
        <div className={styles.remarks}>
          <h3 className={styles.subHeading}>
            Additional Information
          </h3>

          <p className={styles.remarksText}>
            {inventory.remarks}
          </p>
        </div>
      )}

    </section>
  );
}